module.exports = __webpack_public_path__ + "img/forum_thumbnail-400x300.b07ee09c.jpg";